'use client';

import type { FindingSeverityType } from '@terra/shared-schemas-orchestrator';
import { Box, HStack } from '@terra/ui-styled-system';
import { Button, MetaDefault } from '@terra/ui-design-system';

type PendingSeverityChangePillProps = {
  proposedSeverity: FindingSeverityType;
  label: string;
  onClick?: () => void;
};

export function PendingSeverityChangePill({
  proposedSeverity,
  label,
  onClick,
}: PendingSeverityChangePillProps) {
  const content = (
    <HStack
      gap="1.5"
      alignItems="center"
      px="2"
      py="0.5"
      borderRadius="full"
      borderWidth="1px"
      borderStyle="dashed"
      borderColor="border.severity.high"
      color="fg.severity.high"
      bg="transparent"
      whiteSpace="nowrap"
      flexShrink={0}
      aria-label={label}
      title={proposedSeverity}
    >
      <Box
        w="1.5"
        h="1.5"
        borderRadius="full"
        bg="fg.severity.high"
        animation="pulse 2s ease-in-out infinite"
        flexShrink={0}
      />
      <MetaDefault color="fg.severity.high">{label}</MetaDefault>
    </HStack>
  );

  if (!onClick) {
    return content;
  }

  return (
    <Button
      type="button"
      size="2xs"
      variant="ghost"
      display="inline-flex"
      h="auto"
      minH="unset"
      minW="unset"
      p="0"
      m="0"
      bg="transparent"
      boxShadow="none"
      aria-label={label}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      _hover={{ bg: 'transparent' }}
    >
      {content}
    </Button>
  );
}
